import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { User } from '../../../shared/classes/User';
import { MasterService } from 'src/app/shared/services/master.service';
import { UsersService } from '../../../shared/services/users.service';
import { city,UserCity, Practice } from '../../../shared/classes/city';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { takeUntil, audit, timeout } from 'rxjs/operators';
import {Subject} from 'rxjs';
import { UserOffices } from '../../../shared/classes/UserOffices';
import { UserPractices } from '../../../shared/classes/UserPractices';
// import { AuditTrail } from '@shared/classes/AuditTrail';
// import { element } from '@angular/core/src/render3';
import { AuditAttributes } from '../../../shared/classes/Attributes';
//import { RoleType } from 'src/app/Enum/usersFilterEnums';
import { Role } from 'src/app/Enum/role';
import{RoleType,OnStatus} from 'src/app/Enums/usersFilterEnums'
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { element } from 'protractor';
import { AuditData, AuditTrail } from 'src/app/shared/classes/AuditTrail';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.less']
})

export class EditUserComponent implements OnInit, OnDestroy {
  CitySelected: number;
  OfficeSelected: number;
  PracticeSelected: number;
  floorSelected: number;
  isRequestor: boolean = false ;
  isApprover: boolean = false ;
  isL1: boolean = false ;
  isL2: boolean = false ;
  public roleData: any;
  GateSelected: number;
  RoleSelected: number;
  adduserDetails: any;
  edituserDetail:User;
  newofficeData: any;
  officeData: any;
  office:UserOffices;
  UserOffices:UserOffices[];
  practice: UserPractices;
  UserPractices: UserPractices[];
  officeLength: any;
  attributeName: string; 
  deleteFlag:number=0;
  selectedCityListLength:number;
  selectedWorklocation:Array<any>=[];
  selectedCity:Array<any>=[];
  newWorKLocation:Array<any>=[];
  oldWorkLocation:Array<any>=[];
  inActiveWorkLocation:Array<any>=[];
  oldCity:Array<any>=[];
  //cityId:Array<any>=[];
  removedWorkLocation:Array<any>=[];
  selectedPractice:Array<any>=[];
  selectUserRole: { isChecked: boolean } = { isChecked: false };
  // auditResult: Array<AuditTrail> = new Array<AuditTrail>();
  userId: number;
  practiceId: number;
  GateFloorData: Array<any> = [];
  userPersonnelNo: any;
  public cityData: UserCity[];
  public practiceMasterData: Practice[];
  public practiceData: Practice[];
  selectActiveStatus: { isChecked: boolean } = { isChecked: false };
  selectInActiveStatus: { isChecked: boolean } = { isChecked: false };
  selectAdminRole: { isChecked: boolean } = { isChecked: false };
  selectSuperAdminRole: { isChecked: boolean } = { isChecked: false };
  selectSecuritySupervisorRole: { isChecked: boolean } = { isChecked: false };
  selectisrequestor: { isChecked: boolean } = { isChecked: false };
  selectisapprover: { isChecked: boolean } = { isChecked: false };
  selectisL1approver: { isChecked: boolean } = { isChecked: false };
  selectisL2approver: { isChecked: boolean } = { isChecked: false };
  MasterList: any;
  oldValues:any=[];
  newValues:any=[];
  prev_loc:number;
  
  // L1 Approver fields
  selectedL1City: Array<any> = [];
  selectedL1Worklocation: Array<any> = [];
  selectedL1Practice: Array<any> = [];
  L1cityData: UserCity[];
  L1officeData: any;
  L1practiceData: Practice[];
  L1CitySelected: number;
  L1OfficeSelected: number;
  L1PracticeSelected: number;
  
  // L2 Approver fields
  selectedL2City: Array<any> = [];
  selectedL2Worklocation: Array<any> = [];
  selectedL2Practice: Array<any> = [];
  L2cityData: UserCity[];
  L2officeData: any;
  L2practiceData: Practice[];
  L2CitySelected: number;
  L2OfficeSelected: number;
  L2PracticeSelected: number;
  oldDateAdded: any;
  oldAddedBy: any;
  private unsubscribe$ =new Subject<void>();
  private service_URL: any;
  flagval: boolean=false;
  val: boolean = false;
  oldAuditData: any = [];

  oldAuditValues: any = [];
  newAuditValues: any = [];
  auditResult: AuditTrail = new AuditTrail();

  constructor(private _masterService: MasterService, private userService: UsersService, public modalRef: BsModalRef,
    private toast: ToastrService,private _dataContextService: DataContextService,private http:HttpClient,private trackeromnitureservice:TrackerOmnitureService) {
    this.adduserDetails = new User();
    this.edituserDetail= new User();
    this.UserOffices = new Array<UserOffices>();
    this.UserPractices = new Array<UserPractices>();
    this.service_URL = ConstantsService;
    
  }

  
  ngOnInit() {
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('user-edit',username);
    this.trackeromnitureservice.trackPage("pageView");

    this.roleData = this.GetRoles();
    this.userId = this.userPersonnelNo;
    this.GetUserDetails(this.userId);     
  }

  setRadio(value:string)
  {
    if(value == 'admin')
    {
      this.selectSecuritySupervisorRole.isChecked = false;
      this.selectUserRole.isChecked = false  ;
      this.selectSuperAdminRole.isChecked = false;
      this.selectAdminRole.isChecked = true;
      this.RoleSelected = 2;
      this.myFunction(2);
    }
    else if(value=='user')
    {
      this.selectSecuritySupervisorRole.isChecked = false;
      this.selectUserRole.isChecked = true  ;
      this.selectSuperAdminRole.isChecked = false;
      this.selectAdminRole.isChecked = false;
      this.RoleSelected = 4;
      this.myFunction(4);
    }

    else if(value=='superadmin')
    {
      this.selectSecuritySupervisorRole.isChecked = false;
      this.selectUserRole.isChecked = false ;
      this.selectSuperAdminRole.isChecked = true;
      this.selectAdminRole.isChecked = false;
      this.RoleSelected = 1;
      this.myFunction(1);
    }

    else
    {
      this.selectSecuritySupervisorRole.isChecked = true;
      this.selectUserRole.isChecked = false;
      this.selectSuperAdminRole.isChecked = false;
      this.selectAdminRole.isChecked = false;
      this.RoleSelected = 3;
      this.myFunction(3);
    }
  }

  Onchange_practice(k){
    this.practiceId = k;
  }
  
  selectPractice() {
    let item = this.practiceData.find(x => x.practiceId == this.PracticeSelected);
    if(item && this.selectedPractice.indexOf(item) === -1) {
      this.selectedPractice.push(item);
      this.practiceData = this.practiceData.filter(x => x.practiceId != item.practiceId).sort((item1, item2) => (item1.name < item2.name) ? -1 : 1);
    }
    this.PracticeSelected = null;
  }
  
  removePracticeSelected(item) {
    this.selectedPractice = this.selectedPractice.filter(x => x.practiceId !== item.practiceId);
    this.practiceData.push(item);
    this.practiceData = this.practiceData.sort((item1, item2) => (item1.name < item2.name) ? -1 : 1);
  }

  // ============ L1 Approver Methods ============
  selectL1City() {
    let item = this.L1cityData.find(x => x.cityID == this.L1CitySelected);
    if (item && this.selectedL1City.indexOf(item) === -1) {
      this.selectedL1City.push(item);
      this.L1cityData = this.L1cityData.filter(x => x.cityID !== item.cityID).sort((item1, item2) => (item1.cityName < item2.cityName) ? -1 : 1);
    }
    
    this.L1officeData = this.MasterList.officeList
      .filter((office) => this.selectedL1City.some(city => city.cityID === office.cityID))
      .filter((office) => !this.selectedL1Worklocation.some(worklocation => worklocation.officeID === office.officeID))
      .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
    
    this.L1CitySelected = null;
  }

  removeL1City(item) {
    this.selectedL1City = this.selectedL1City.filter(x => x.cityID !== item.cityID);
    this.L1cityData.push(item);
    this.L1cityData.sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));
    
    this.selectedL1Worklocation = this.selectedL1Worklocation.filter(x => x.cityID !== item.cityID);
    this.L1officeData = this.MasterList.officeList
      .filter((office) => this.selectedL1City.some(city => city.cityID === office.cityID))
      .filter((office) => !this.selectedL1Worklocation.some(worklocation => worklocation.officeID === office.officeID))
      .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  }

  selectL1WorkLocation() {
    let item = this.L1officeData.find(x => x.officeID == this.L1OfficeSelected);
    if (item && this.selectedL1Worklocation.indexOf(item) === -1) {
      this.selectedL1Worklocation.push(item);
      this.L1officeData = this.L1officeData.filter(x => x.officeID !== item.officeID).sort((item1, item2) => (item1.officeName < item2.officeName) ? -1 : 1);
    }
    this.L1OfficeSelected = null;
  }

  removeL1WorkLocation(item) {
    this.selectedL1Worklocation = this.selectedL1Worklocation.filter(x => x.officeID !== item.officeID);
    this.L1officeData.push(item);
    this.L1officeData.sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
    
    // Remove L1 city if no more L1 work locations from that city
    const cityStillHasOffices = this.selectedL1Worklocation.some(w => w.cityID === item.cityID);
    if (!cityStillHasOffices) {
      const city = this.selectedL1City.find(c => c.cityID === item.cityID);
      if (city) {
        this.selectedL1City = this.selectedL1City.filter(c => c.cityID !== item.cityID);
        this.L1cityData.push(city);
        this.L1cityData.sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));
      }
    }
  }

  selectL1Practice() {
    let item = this.L1practiceData.find(x => x.practiceId == this.L1PracticeSelected);
    if (item && this.selectedL1Practice.indexOf(item) === -1) {
      this.selectedL1Practice.push(item);
      this.L1practiceData = this.L1practiceData.filter(x => x.practiceId !== item.practiceId).sort((item1, item2) => (item1.name < item2.name) ? -1 : 1);
    }
    this.L1PracticeSelected = null;
  }

  removeL1Practice(item) {
    this.selectedL1Practice = this.selectedL1Practice.filter(x => x.practiceId !== item.practiceId);
    this.L1practiceData.push(item);
    this.L1practiceData.sort((item1, item2) => (item1.name < item2.name ? -1 : 1));
  }

  // ============ L2 Approver Methods ============
  selectL2City() {
    let item = this.L2cityData.find(x => x.cityID == this.L2CitySelected);
    if (item && this.selectedL2City.indexOf(item) === -1) {
      this.selectedL2City.push(item);
      this.L2cityData = this.L2cityData.filter(x => x.cityID !== item.cityID).sort((item1, item2) => (item1.cityName < item2.cityName) ? -1 : 1);
    }
    
    this.L2officeData = this.MasterList.officeList
      .filter((office) => this.selectedL2City.some(city => city.cityID === office.cityID))
      .filter((office) => !this.selectedL2Worklocation.some(worklocation => worklocation.officeID === office.officeID))
      .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
    
    this.L2CitySelected = null;
  }

  removeL2City(item) {
    this.selectedL2City = this.selectedL2City.filter(x => x.cityID !== item.cityID);
    this.L2cityData.push(item);
    this.L2cityData.sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));
    
    this.selectedL2Worklocation = this.selectedL2Worklocation.filter(x => x.cityID !== item.cityID);
    this.L2officeData = this.MasterList.officeList
      .filter((office) => this.selectedL2City.some(city => city.cityID === office.cityID))
      .filter((office) => !this.selectedL2Worklocation.some(worklocation => worklocation.officeID === office.officeID))
      .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  }

  selectL2WorkLocation() {
    let item = this.L2officeData.find(x => x.officeID == this.L2OfficeSelected);
    if (item && this.selectedL2Worklocation.indexOf(item) === -1) {
      this.selectedL2Worklocation.push(item);
      this.L2officeData = this.L2officeData.filter(x => x.officeID !== item.officeID).sort((item1, item2) => (item1.officeName < item2.officeName) ? -1 : 1);
    }
    this.L2OfficeSelected = null;
  }

  removeL2WorkLocation(item) {
    this.selectedL2Worklocation = this.selectedL2Worklocation.filter(x => x.officeID !== item.officeID);
    this.L2officeData.push(item);
    this.L2officeData.sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
    
    // Remove L2 city if no more L2 work locations from that city
    const cityStillHasOffices = this.selectedL2Worklocation.some(w => w.cityID === item.cityID);
    if (!cityStillHasOffices) {
      const city = this.selectedL2City.find(c => c.cityID === item.cityID);
      if (city) {
        this.selectedL2City = this.selectedL2City.filter(c => c.cityID !== item.cityID);
        this.L2cityData.push(city);
        this.L2cityData.sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));
      }
    }
  }

  selectL2Practice() {
    let item = this.L2practiceData.find(x => x.practiceId == this.L2PracticeSelected);
    if (item && this.selectedL2Practice.indexOf(item) === -1) {
      this.selectedL2Practice.push(item);
      this.L2practiceData = this.L2practiceData.filter(x => x.practiceId !== item.practiceId).sort((item1, item2) => (item1.name < item2.name) ? -1 : 1);
    }
    this.L2PracticeSelected = null;
  }

  removeL2Practice(item) {
    this.selectedL2Practice = this.selectedL2Practice.filter(x => x.practiceId !== item.practiceId);
    this.L2practiceData.push(item);
    this.L2practiceData.sort((item1, item2) => (item1.name < item2.name ? -1 : 1));
  }

  GetRoles()
  {
    return [
      {
        roleId : 1,
        roleName : Role.SuperAdmin
      },
      {
        roleId : 2,
        roleName : Role.Admin
      },
      {
        roleId : 3,
        roleName : Role.SecuritySupervisior
      },
      {
        roleId : 4,
        roleName : Role.User
      },
    ]
  }
  //Get the details on clicking edit button
  GetUserDetails(id: number) {
    this.userService.getUsersDataById(id)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((data) => {
      this.adduserDetails = data;
      console.log('GetUserDetails - data:', data);    
      this.oldDateAdded = data.userData.dateAdded;
      this.oldAddedBy = data.userData.addedBy;
      this.adduserDetails.Id = data.userData.appUserID;
      this.adduserDetails.userName = data.userData.firstName + "," + data.userData.lastName;
      this.adduserDetails.isActive = data.userData.isActive;
      this.adduserDetails.RoleId = data.userData.roleID;
      this.RoleSelected = data.userData.roleID; // Set RoleSelected for L1/L2 visibility
      this.PracticeSelected = data.userData.practiceID;
      if(data.userData.isActive==true)
      {
        this.selectActiveStatus.isChecked=true;
      }
      else
      {
        this.selectInActiveStatus.isChecked=true;
      }
      
      this.global_1(data); 
      this.adduserDetails.EmailId = data.userData.emailId;
      this.adduserDetails.officeID = data.userOffice || data.userOffices;
      
      // Map backend response to expected structure
      // Handle both array and single object formats
      if (data.userOffice && Array.isArray(data.userOffice)) {
        this.adduserDetails.userOffices = data.userOffice;
      } else if (data.userOffice && Array.isArray(data.userOffice)) {
        this.adduserDetails.userOffices = data.userOffice;
      } else if (data.userOffice) {
        // Single object - convert to array
        this.adduserDetails.userOffices = [data.userOffice];
      } else {
        this.adduserDetails.userOffices = [];
      }
      
      if (data.userPractices && Array.isArray(data.userPractices)) {
        this.adduserDetails.userPractices = data.userPractices;
      } else if (data.userPractice && Array.isArray(data.userPractice)) {
        this.adduserDetails.userPractices = data.userPractice;
      } else if (data.userPractice) {
        // Single object - convert to array
        this.adduserDetails.userPractices = [data.userPractice];
      } else {
        this.adduserDetails.userPractices = [];
      }
      
      console.log('GetUserDetails - userOffices:', this.adduserDetails.userOffices);
      console.log('GetUserDetails - userPractices:', this.adduserDetails.userPractices);
      console.log('GetUserDetails - userData.officeID:', data.userData.officeID);
      console.log('GetUserDetails - userData.cityID:', data.userData.cityID);
      
      this.edituserDetail=Object.assign({},this.adduserDetails);

      //Set Old Values from here
      this.oldAuditData = this.adduserDetails;

      var obj = {
        oldRoleId : this.oldAuditData.userData.roleID,
        oldisActive : this.oldAuditData.isActive,
        oldworkLocation : this.oldAuditData.userOffice,
        oldCityId : this.oldAuditData.userData.cityID,
        oldisRequestor: this.oldAuditData.userData.isRequestor,
        oldisApprover: this.oldAuditData.userData.isApprover,
        oldisL1: this.oldAuditData.userData.isL1,
        oldisL2: this.oldAuditData.userData.isL2,
        oldisPracticeID: this.oldAuditData.userData.practiceID
      }

      this.oldValues.push(obj);
      this.BindCityDropdown();
      
   })
  }

   onCheckboxChange(check : string )
  {
    if(check == 'requestor')
    {
      this.selectisrequestor.isChecked = !this.selectisrequestor.isChecked;
      this.isRequestor = this.selectisrequestor.isChecked;
    }
    else if(check == 'approver')
    {
      this.selectisapprover.isChecked = !this.selectisapprover.isChecked;
      this.isApprover = this.selectisapprover.isChecked;
   
      // If unchecking approver, also uncheck L1 and L2
      if(!this.isApprover) {
        this.selectisL1approver.isChecked = false;
        this.isL1 = false;
        this.selectisL2approver.isChecked = false;
        this.isL2 = false;
      }
      
      // Do NOT remove Requestor's city and work location when switching checkboxes
      // Each role (Requestor, L1, L2) maintains its own selections independently
    }
   }

  onApproverChange(check : string)
  {
    if(check == 'L1')
    {
      this.selectisL1approver.isChecked = !this.selectisL1approver.isChecked;
      this.isL1 = this.selectisL1approver.isChecked;
    }
    else if(check == 'L2')
    {
      this.selectisL2approver.isChecked = !this.selectisL2approver.isChecked;
      this.isL2 = this.selectisL2approver.isChecked;
    }
  }

  // global_2(k : boolean) {
  //   if(k == false) {
  //     this.selectisL1approver.isChecked = false;
  //     this.selectisL2approver.isChecked = false;
  //     this.flagval = false;
  //   }
  // }

  global_2(k: boolean): void {
    this.selectisapprover.isChecked = k;
  
    if (!this.selectisapprover.isChecked) {
      // Do NOT clear selectedCity and selectedWorklocation - those belong to Requestor
      // Only reset L1/L2 approver checkboxes
      if(k == false) {
        this.selectisL1approver.isChecked = false;
        this.selectisL2approver.isChecked = false;
        this.isL1 = false;
        this.isL2 = false;
        this.flagval = false;
      }
    }
  }

  // global_1(data)
  // {
  //   console.log('global_1 called with data:', data);
  //   if(data.userData.isRequestor==true && data.userData.isApprover == true)   //For both Req, Approver , L1 & L2.
  //     {
  //       this.selectisrequestor.isChecked=true;
  //       this.selectisapprover.isChecked=true;
  //       if(data.userData.isL1==true && data.userData.isL2 == true)
  //       {
  //         this.selectisL1approver.isChecked=true;
  //         this.selectisL2approver.isChecked=true;
  //       }
      
  //       else if(data.userData.isL1==true && data.userData.isL2 == false)
  //       {
  //         this.selectisL1approver.isChecked=true;
  //       }
        
  //       else this.selectisL2approver.isChecked=true;
  //     }
      
  //     else if(data.userData.isRequestor==false && data.userData.isApprover == true)
  //     {
  //       this.selectisapprover.isChecked = true;
  //       if(data.isL1==true && data.isL2 == true)
  //       {
  //         this.selectisL1approver.isChecked=true;
  //         this.selectisL2approver.isChecked=true;
  //       }

  //       else if(data.userData.isL1==true && data.userData.isL2 == false)
  //        { 
  //           this.selectisL1approver.isChecked=true;
  //        }

  //       else
  //         this.selectisL2approver.isChecked=true;
  //     }
  //     else if(data.userData.isRequestor== true && data.userData.isApprover == false)
  //     {
  //       this.selectisrequestor.isChecked=true;
  //     }
  // }
  global_1(data) {
    console.log('global_1 called with data:', data);
    if (data.userData.isRequestor == true && data.userData.isApprover == true) { // For both Req, Approver, L1 & L2.
      this.selectisrequestor.isChecked = true;
      this.selectisapprover.isChecked = true;
      if (data.userData.isL1 == true && data.userData.isL2 == true) {
        this.selectisL1approver.isChecked = true;
        this.selectisL2approver.isChecked = true;
      } else if (data.userData.isL1 == true && data.userData.isL2 == false) {
        this.selectisL1approver.isChecked = true;
        this.selectisL2approver.isChecked = false;
      } else {
        this.selectisL1approver.isChecked = false;
        this.selectisL2approver.isChecked = true;
      }
    } else if (data.userData.isRequestor == false && data.userData.isApprover == true) {
      this.selectisapprover.isChecked = true;
      if (data.userData.isL1 == true && data.userData.isL2 == true) {
        this.selectisL1approver.isChecked = true;
        this.selectisL2approver.isChecked = true;
      } else if (data.userData.isL1 == true && data.userData.isL2 == false) {
        this.selectisL1approver.isChecked = true;
        this.selectisL2approver.isChecked = false;
      } else {
        this.selectisL1approver.isChecked = false;
        this.selectisL2approver.isChecked = true;
      }
    } else if (data.userData.isRequestor == true && data.userData.isApprover == false) {
      this.selectisrequestor.isChecked = true;
      this.selectisapprover.isChecked = false;
      this.selectisL1approver.isChecked = false;
      this.selectisL2approver.isChecked = false;
    } else {
      this.selectisrequestor.isChecked = false;
      this.selectisapprover.isChecked = false;
      this.selectisL1approver.isChecked = false;
      this.selectisL2approver.isChecked = false;
    }
    
    // Sync boolean flags with checkbox states
    this.isRequestor = this.selectisrequestor.isChecked;
    this.isApprover = this.selectisapprover.isChecked;
    this.isL1 = this.selectisL1approver.isChecked;
    this.isL2 = this.selectisL2approver.isChecked;
    
    console.log('After global_1 - isRequestor:', this.selectisrequestor.isChecked, 'isApprover:', this.selectisapprover.isChecked, 'isL1:', this.selectisL1approver.isChecked, 'isL2:', this.selectisL2approver.isChecked);
  }
    
  selectRole()
  {
    // console.log(this.RoleSelected);
  }
  //Bind the city Dropdown
  BindCityDropdown() {
    
    this._dataContextService.get<any>(this.service_URL.Users.getMasterData)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
       
      this.MasterList = res;
      if (this.adduserDetails.RoleId ==  this.roleData.find(x=> x.roleName == Role.Admin).roleId) {
        this.selectAdminRole.isChecked = true;
      }
      else if(this.adduserDetails.RoleId == this.roleData.find(x=> x.roleName == Role.SecuritySupervisior).roleId) {
        this.selectSecuritySupervisorRole.isChecked = true;
      }
      else if(this.adduserDetails.RoleId == this.roleData.find(x=> x.roleName == Role.SuperAdmin).roleId) {
        this.selectSuperAdminRole.isChecked = true;
      }
      else
      {
        this.selectUserRole.isChecked=true;
      }
      this.cityData = this.MasterList.cityList;   
      this.practiceMasterData = this.MasterList.practiceList;
      this.practiceData = this.MasterList.practiceList.filter(practice => practice.practiceId !== 0);
      
      // Initialize L1 and L2 dropdown data
      this.L1cityData = [...this.MasterList.cityList];
      this.L1practiceData = this.MasterList.practiceList.filter(practice => practice.practiceId !== 0);
      this.L2cityData = [...this.MasterList.cityList];
      this.L2practiceData = this.MasterList.practiceList.filter(practice => practice.practiceId !== 0);
      
      this.CitySelected = this.adduserDetails.userData.cityID;
      this.oldCity = [];
      this.selectedCity = [];
      
      // BindOfficeDropdown will populate selectedCity and selectedWorklocation from userOffices
      // So we don't manually add cities here - let BindOfficeDropdown handle it
      this.BindOfficeDropdown(null);
    })


  }
 
  showbutton()
    {
      // Return true (disabled) if data not yet loaded from API
      //if (this.RoleSelected === null || this.RoleSelected === undefined) {
      //  return true;
      //}
      
      // For Admin/SuperAdmin (roles 1 and 2), all checkboxes are auto-checked
      if (this.RoleSelected === 1 || this.RoleSelected === 2) {
        if (!this.PracticeSelected || this.PracticeSelected === 0) {
          return true;
        }
        if (this.selectedWorklocation.length === 0 || this.selectedCity.length === 0) {
          return true;
        }
        this.flagval = false;
        return false;
      }
      
      // For User/SecuritySupervisor (roles 3 and 4)
      if (this.RoleSelected === 3 || this.RoleSelected === 4) {
        // Check if at least one role is selected
        if(!this.selectisrequestor.isChecked && !this.selectisapprover.isChecked && !this.selectisL1approver.isChecked && !this.selectisL2approver.isChecked)
        {
          return true;
        }
        
        // If only approver is checked without L1/L2, disable (approver needs L1 or L2)
        if(this.selectisapprover.isChecked && !this.selectisL1approver.isChecked && !this.selectisL2approver.isChecked && !this.selectisrequestor.isChecked)
        {
          return true;
        }
        
        // Check if L1/L2 requirements are met
        let l1Valid = true;
        let l2Valid = true;
        
        // If L1 is checked, require L1 work locations and practice
        if(this.selectisL1approver.isChecked) {
          if (this.selectedL1Worklocation.length === 0 || this.selectedL1Practice.length === 0) {
            l1Valid = false;
          }
        }
        
        // If L2 is checked, require L2 work locations and practice
        if(this.selectisL2approver.isChecked) {
          if (this.selectedL2Worklocation.length === 0 || this.selectedL2Practice.length === 0) {
            l2Valid = false;
          }
        }
        
        // Check if requestor requirements are met
        let requestorValid = true;
        if (this.selectisrequestor.isChecked) {
          // Requestor only needs work location if NO approver roles are checked OR approver fields are incomplete
          const hasApproverRoles = this.selectisL1approver.isChecked || this.selectisL2approver.isChecked;
          const approverFieldsComplete = (!this.selectisL1approver.isChecked || l1Valid) && (!this.selectisL2approver.isChecked || l2Valid);
          
          if (!hasApproverRoles || !approverFieldsComplete) {
            // Requestor needs its own work location
            if (this.selectedWorklocation.length === 0 || this.selectedCity.length === 0) {
              requestorValid = false;
            }
          }
        }
        
        // Enable button only if all checked roles have valid fields
        if (!l1Valid || !l2Valid || !requestorValid) {
          return true;
        }
        
        this.flagval = false;
        return false;
      }
      
      // Default: disable
      return true;
    }
  
  //Bind the office Dropdown
//   BindOfficeDropdown(event) {
    
//     this.officeData = this.MasterList.officeList;
//     // if(event==null)
//     // {
//     //  let item=this.cityData.find(x=>x.cityID);
//     //  this.cityData=this.cityData.filter(x=>x.cityID==item.cityID).sort((item1,item2)=>(item1.cityName < item2.cityName)?-1:1);
//     //  if(this.selectedCity.indexOf(item)===-1)
//     //  {
//     //    //this.selectedCity.push(item);
//     //  }
//      this.cityData=this.MasterList.cityList;
    
//     this.prev_loc = this.adduserDetails.userData.cityID;
//     if(this.CitySelected==this.adduserDetails.userData.cityID){   
//       event=null;
//       this.oldWorkLocation=[];
//     }
//     if(event==null){
  
//     for( let Id in this.adduserDetails.officeID){
//       let data=this.officeData.find(x=>x.officeID === this.adduserDetails.officeID[Id].officeID);
//       if(data!=undefined && data!=null)
//       if(this.selectedWorklocation.indexOf(data)===-1)
//       {
//       this.selectedWorklocation.push(data);
//       }
//        this.oldWorkLocation.push(data);
//        this.officeData=this.officeData.filter((item) => {
//         return item.officeID !== this.adduserDetails.officeID[Id].officeID
//       }).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
//     }
//     }

//      // Update selectedCity without overwriting existing cities
//     this.selectedCity = [];
//      this.selectedWorklocation.forEach(workLocation => {
//       let city = this.MasterList.cityList.find(city => city.cityID === workLocation.cityID);
//       if (city && this.selectedCity.indexOf(city) === -1) {
//           this.selectedCity.push(city); // Add city if not already in selectedCity
//       }
//   });

//   // Sort selectedCity alphabetically by cityName
//   this.selectedCity.sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));

    
//     let i=0;
//     var l=this.selectedWorklocation.length; 
//     if(event!=null)
//     {
//       for(i=0;i<l;i++) 
//       {
//         this.removeWorkLocation(null,this.selectedWorklocation[0]);
//       }        
//     }
//     // Update selectedCity based on selectedWorklocation
//   this.selectedCity = [];
//   this.selectedWorklocation.forEach(workLocation => {
//     let city = this.MasterList.cityList.find(city => city.cityID === workLocation.cityID);
//     if (city && this.selectedCity.indexOf(city) === -1) {
//       this.selectedCity.push(city);
//     }
//   });

//   // Sort selectedCity alphabetically by cityName
//   this.selectedCity.sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));
//     var tempo : Array<any>=[];
//     var temp : Array<any>=[];
//     var temp1 : Array<any>=[];
    
//     for(i=0;i<this.selectedCity.length;i++){
//         tempo= this.MasterList.officeList.filter((item) => {
//           return item.cityID === this.CitySelected;
//         });
//          temp = temp.concat(tempo);
//       }
//       this.officeData =   temp.sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
//       //this.selectNewWorkLocations(event);
  
// }
BindOfficeDropdown(event) {
  this.officeData = this.MasterList.officeList;

  // Filter out already selected work locations to avoid duplicates
  this.officeData = this.officeData.filter(office => 
    !this.selectedWorklocation.some(selected => selected.officeID === office.officeID)
  );

  // Sort the officeData alphabetically by officeName
  this.officeData = this.officeData.sort((item1, item2) => 
    item1.officeName < item2.officeName ? -1 : 1
  );

  // Handle previous locations and selected work locations
  this.prev_loc = this.adduserDetails.userData.cityID;
  if (this.CitySelected === this.adduserDetails.userData.cityID) {   
    event = null;
    this.oldWorkLocation = [];
  }

  if (event === null) {
    console.log('BindOfficeDropdown - userOffices:', this.adduserDetails.userOffices);
    console.log('BindOfficeDropdown - userData.officeID:', this.adduserDetails.userData.officeID);
    console.log('BindOfficeDropdown - userData.cityID:', this.adduserDetails.userData.cityID);
    
    // Check if userOffices array has data (new format)
    if (this.adduserDetails.userOffices && Array.isArray(this.adduserDetails.userOffices) && this.adduserDetails.userOffices.length > 0) {
      console.log('Using userOffices array format');
      // New format: Populate selectedWorklocation from userOffices
      this.adduserDetails.userOffices.forEach(userOffice => {
        // For Admin and Super Admin (RoleID 1 or 2), add all work locations
        const isAdminOrSuperAdmin = this.adduserDetails.RoleId === 1 || this.adduserDetails.RoleId === 2;
        
        // Use capital I: IsRequestor (not isRequestor) to match the class property
        const isRequestorOffice = userOffice.IsRequestor !== undefined ? userOffice.IsRequestor : 
                                  userOffice.isRequestor !== undefined ? userOffice.isRequestor : 
                                  false;
        
        // For old data compatibility: if ALL flags are false or undefined, assume it's a requestor office
        const allFlagsFalse = (!userOffice.IsRequestor && !userOffice.isRequestor && !userOffice.isL1 && !userOffice.isL2);
        const noFlagsSet = userOffice.IsRequestor === undefined && userOffice.isL1 === undefined && userOffice.isL2 === undefined;
        
        // Load requestor offices into selectedWorklocation (even if they also have L1/L2 flags)
        // This ensures requestor city/work location displays correctly for users with multiple roles
        // For old data where all flags are false, treat as requestor office if user has isRequestor role
        const treatAsRequestor = allFlagsFalse && this.adduserDetails.userData.isRequestor;
        
        if (isAdminOrSuperAdmin || isRequestorOffice || noFlagsSet || treatAsRequestor) {
          let data = this.MasterList.officeList.find(x => x.officeID === userOffice.officeID);
          if (data && !this.selectedWorklocation.some(selected => selected.officeID === data.officeID)) {
            this.selectedWorklocation.push(data);
            this.oldWorkLocation.push(data);
            console.log('Added office:', data.officeName);
          }
        }
      });
    } else if (this.adduserDetails.userData && this.adduserDetails.userData.officeID) {
      console.log('Using userData.officeID fallback');
      // Legacy format: Use userData.officeID (single office for old records)
      let data = this.MasterList.officeList.find(x => x.officeID === this.adduserDetails.userData.officeID);
      if (data && !this.selectedWorklocation.some(selected => selected.officeID === data.officeID)) {
        this.selectedWorklocation.push(data);
        this.oldWorkLocation.push(data);
        console.log('Added office to selectedWorklocation:', data);
      } else {
        console.log('Office not found or already exists:', this.adduserDetails.userData.officeID);
      }
    } else {
      console.log('No office data found in userOffices or userData.officeID');
    }
    
    console.log('Final selectedWorklocation:', this.selectedWorklocation);
  }

  // Update selectedCity based on selectedWorklocation (only if there are work locations)
  console.log('=== POPULATING CITIES FROM WORK LOCATIONS ===');
  console.log('selectedWorklocation.length:', this.selectedWorklocation.length);
  
  if (this.selectedWorklocation.length > 0) {
    this.selectedCity = [];
    this.selectedWorklocation.forEach(workLocation => {
      console.log('Processing workLocation:', workLocation.officeName, 'cityID:', workLocation.cityID);
      let city = this.MasterList.cityList.find(city => city.cityID === workLocation.cityID);
      if (city) {
        console.log('Found city:', city.cityName, 'cityID:', city.cityID);
        if (!this.selectedCity.some(selected => selected.cityID === city.cityID)) {
          this.selectedCity.push(city);
          console.log('✓ Added city to selectedCity:', city.cityName);
        } else {
          console.log('⚠ City already in selectedCity:', city.cityName);
        }
      } else {
        console.log('✗ City NOT found for cityID:', workLocation.cityID);
        console.log('Available cities:', this.MasterList.cityList.map(c => c.cityID + ':' + c.cityName));
      }
    });

    // Sort selectedCity alphabetically by cityName
    this.selectedCity.sort((item1, item2) => 
      item1.cityName < item2.cityName ? -1 : 1
    );
    
    console.log('Final selectedCity:', this.selectedCity);
  } else {
    console.log('No work locations to process for cities');
  }

  // Update officeData based on selectedCity
  let updatedOfficeData: Array<any> = [];
  this.selectedCity.forEach(city => {
    let cityOffices = this.MasterList.officeList.filter(office => office.cityID === city.cityID);
    updatedOfficeData = updatedOfficeData.concat(cityOffices);
  });

  // Exclude already selected work locations from the dropdown
  this.officeData = updatedOfficeData.filter(office => 
    !this.selectedWorklocation.some(workLocation => workLocation.officeID === office.officeID)
  ).sort((item1, item2) => 
    item1.officeName < item2.officeName ? -1 : 1
  );
  
  // Update cityData dropdown to exclude already selected cities
  this.cityData = this.MasterList.cityList.filter(city => 
    !this.selectedCity.some(selected => selected.cityID === city.cityID)
  ).sort((item1, item2) => 
    item1.cityName < item2.cityName ? -1 : 1
  );
  
  // Populate L1/L2 arrays from backend data
  this.populateL1L2SelectionsFromBackend();
}

populateL1L2SelectionsFromBackend() {
  console.log('=== POPULATE L1/L2 FROM BACKEND ===');
  
  // Clear existing L1/L2 selections
  this.selectedL1City = [];
  this.selectedL1Worklocation = [];
  this.selectedL1Practice = [];
  this.selectedL2City = [];
  this.selectedL2Worklocation = [];
  this.selectedL2Practice = [];
  
  // Populate L1 and L2 offices from userOffices (same logic as requestor)
  if (this.adduserDetails.userOffices && Array.isArray(this.adduserDetails.userOffices) && this.adduserDetails.userOffices.length > 0) {
    console.log('Processing userOffices for L1/L2:', this.adduserDetails.userOffices);
    
    this.adduserDetails.userOffices.forEach(userOffice => {
      const office = this.MasterList.officeList.find(o => o.officeID === userOffice.officeID);
      
      if (office) {
        console.log('Processing office:', office.officeName, 'isL1:', userOffice.isL1, 'isL2:', userOffice.isL2);
        
        // Check L1 flag (same comprehensive logic as requestor IsRequestor check)
        const isL1Office = userOffice.isL1 === true;
        
        // For old data compatibility: if ALL flags are false, check userData.isL1 
        const allFlagsFalse = (!userOffice.IsRequestor && !userOffice.isRequestor && !userOffice.isL1 && !userOffice.isL2);
        const treatAsL1 = allFlagsFalse && this.adduserDetails.userData.isL1;
        
        if (isL1Office || treatAsL1) {
          // Add L1 office
          if (!this.selectedL1Worklocation.some(w => w.officeID === office.officeID)) {
            this.selectedL1Worklocation.push(office);
            console.log('✓ Added L1 office:', office.officeName);
          }
        }
        
        // Check L2 flag (same comprehensive logic as requestor IsRequestor check)
        const isL2Office = userOffice.isL2 === true;
        const treatAsL2 = allFlagsFalse && this.adduserDetails.userData.isL2;
        
        if (isL2Office || treatAsL2) {
          // Add L2 office
          if (!this.selectedL2Worklocation.some(w => w.officeID === office.officeID)) {
            this.selectedL2Worklocation.push(office);
            console.log('✓ Added L2 office:', office.officeName);
          }
        }
      }
    });
    
    // NOW derive L1 cities from L1 work locations (same as requestor logic)
    console.log('=== DERIVING L1 CITIES FROM WORK LOCATIONS ===');
    console.log('selectedL1Worklocation.length:', this.selectedL1Worklocation.length);
    
    if (this.selectedL1Worklocation.length > 0) {
      this.selectedL1Worklocation.forEach(workLocation => {
        console.log('Processing L1 workLocation:', workLocation.officeName, 'cityID:', workLocation.cityID);
        let city = this.MasterList.cityList.find(city => city.cityID === workLocation.cityID);
        if (city && !this.selectedL1City.some(selected => selected.cityID === city.cityID)) {
          this.selectedL1City.push(city);
          console.log('✓ Added L1 city:', city.cityName);
        }
      });
      
      // Sort L1 cities
      this.selectedL1City.sort((item1, item2) => item1.cityName < item2.cityName ? -1 : 1);
      console.log('Final selectedL1City:', this.selectedL1City);
    }
    
    // NOW derive L2 cities from L2 work locations (same as requestor logic)
    console.log('=== DERIVING L2 CITIES FROM WORK LOCATIONS ===');
    console.log('selectedL2Worklocation.length:', this.selectedL2Worklocation.length);
    
    if (this.selectedL2Worklocation.length > 0) {
      this.selectedL2Worklocation.forEach(workLocation => {
        console.log('Processing L2 workLocation:', workLocation.officeName, 'cityID:', workLocation.cityID);
        let city = this.MasterList.cityList.find(city => city.cityID === workLocation.cityID);
        if (city && !this.selectedL2City.some(selected => selected.cityID === city.cityID)) {
          this.selectedL2City.push(city);
          console.log('✓ Added L2 city:', city.cityName);
        }
      });
      
      // Sort L2 cities
      this.selectedL2City.sort((item1, item2) => item1.cityName < item2.cityName ? -1 : 1);
      console.log('Final selectedL2City:', this.selectedL2City);
    }
    
  } else if (this.adduserDetails.userData && this.adduserDetails.userData.officeID && this.adduserDetails.userData.cityID) {
    // Fallback for empty userOffices: Use userData.officeID and cityID
    console.log('Using userData fallback for L1/L2');
    const office = this.MasterList.officeList.find(o => o.officeID === this.adduserDetails.userData.officeID);
    const city = this.MasterList.cityList.find(c => c.cityID === this.adduserDetails.userData.cityID);
    
    // Check if user is L1 or L2 approver from userData
    if (this.adduserDetails.userData.isL1 && office && city) {
      if (!this.selectedL1Worklocation.some(w => w.officeID === office.officeID)) {
        this.selectedL1Worklocation.push(office);
        console.log('✓ Added L1 office from fallback:', office.officeName);
      }
      if (!this.selectedL1City.some(c => c.cityID === city.cityID)) {
        this.selectedL1City.push(city);
        console.log('✓ Added L1 city from fallback:', city.cityName);
      }
    }
    
    if (this.adduserDetails.userData.isL2 && office && city) {
      if (!this.selectedL2Worklocation.some(w => w.officeID === office.officeID)) {
        this.selectedL2Worklocation.push(office);
        console.log('✓ Added L2 office from fallback:', office.officeName);
      }
      if (!this.selectedL2City.some(c => c.cityID === city.cityID)) {
        this.selectedL2City.push(city);
        console.log('✓ Added L2 city from fallback:', city.cityName);
      }
    }
  }
  
  // ===== ADMIN/SUPERADMIN PRACTICE LOGIC (SEPARATE) =====
  // For Admin/SuperAdmin: ALWAYS use userData.practiceID directly (single practice)
  // This is independent of userPractices array
  if ((this.adduserDetails.RoleId === 1 || this.adduserDetails.RoleId === 2) && 
      this.adduserDetails.userData && this.adduserDetails.userData.practiceID) {
    this.PracticeSelected = this.adduserDetails.userData.practiceID;
    console.log('=== ADMIN/SUPERADMIN PRACTICE ===');
    console.log('✓ Set PracticeSelected from userData.practiceID:', this.PracticeSelected);
  }
  
  // ===== USER/SECURITY SUPERVISOR PRACTICE LOGIC =====
  // Populate requestor and L1/L2 practices from userPractice array for User/Security Supervisor only
  if ((this.adduserDetails.RoleId === 3 || this.adduserDetails.RoleId === 4) &&
      this.adduserDetails.userPractices && Array.isArray(this.adduserDetails.userPractices) && 
      this.adduserDetails.userPractices.length > 0) {
    console.log('=== USER/SECURITY SUPERVISOR PRACTICES ===');
    console.log('Loading practices from userPractices array');
    this.adduserDetails.userPractices.forEach(userPractice => {
      // API returns practiceID (capital ID)
      const practiceIdFromApi = userPractice.practiceID || userPractice.PracticeId || userPractice.practiceId;
      const practice = this.practiceMasterData.find(p => p.practiceId === practiceIdFromApi);
      
      if (practice) {
        // Populate requestor practice for User/Security Supervisor roles
        // For old data: if no flags set (isL1/isL2 are undefined or false), assume it's requestor practice
        const noFlagsSet = !userPractice.isL1 && !userPractice.isL2;
        if (noFlagsSet) {
          if (!this.selectedPractice.some(p => p.practiceId === practice.practiceId)) {
            this.selectedPractice.push(practice);
            console.log('✓ Added to selectedPractice (requestor):', practice.name);
          }
        }
        
        if (userPractice.isL1) {
          if (!this.selectedL1Practice.some(p => p.practiceId === practice.practiceId)) {
            this.selectedL1Practice.push(practice);
            console.log('✓ Added to selectedL1Practice:', practice.name);
          }
        }
        
        if (userPractice.isL2) {
          if (!this.selectedL2Practice.some(p => p.practiceId === practice.practiceId)) {
            this.selectedL2Practice.push(practice);
            console.log('✓ Added to selectedL2Practice:', practice.name);
          }
        }
      }
    });
  }
  
  // ===== L1/L2 PRACTICES FOR ALL ROLES =====
  // Process L1/L2 practices from userPractices array (for any role that has L1/L2 checked)
  if (this.adduserDetails.userPractices && Array.isArray(this.adduserDetails.userPractices) && 
      this.adduserDetails.userPractices.length > 0) {
    this.adduserDetails.userPractices.forEach(userPractice => {
      const practiceIdFromApi = userPractice.practiceID || userPractice.PracticeId || userPractice.practiceId;
      const practice = this.practiceMasterData.find(p => p.practiceId === practiceIdFromApi);
      
      if (practice) {
        // L1 practices
        if (userPractice.isL1 && !this.selectedL1Practice.some(p => p.practiceId === practice.practiceId)) {
          this.selectedL1Practice.push(practice);
          console.log('✓ Added L1 practice for any role:', practice.name);
        }
        
        // L2 practices
        if (userPractice.isL2 && !this.selectedL2Practice.some(p => p.practiceId === practice.practiceId)) {
          this.selectedL2Practice.push(practice);
          console.log('✓ Added L2 practice for any role:', practice.name);
        }
      }
    });
  }
  
  // ===== FALLBACK LOGIC (User/Security Supervisor only) =====
  // If userPractices is empty for User/Security Supervisor, use userData.practiceID
  if ((this.adduserDetails.RoleId === 3 || this.adduserDetails.RoleId === 4) &&
      (!this.adduserDetails.userPractices || this.adduserDetails.userPractices.length === 0) && 
      this.adduserDetails.userData && this.adduserDetails.userData.practiceID) {
    console.log('=== PRACTICE FALLBACK LOGIC (User/Security Supervisor) ===');
    console.log('userPractices empty - using fallback userData.practiceID:', this.adduserDetails.userData.practiceID);
    console.log('User RoleID:', this.adduserDetails.RoleId);
    console.log('User isRequestor:', this.adduserDetails.userData.isRequestor);
    console.log('User isL1:', this.adduserDetails.userData.isL1);
    console.log('User isL2:', this.adduserDetails.userData.isL2);
    
    const practice = this.practiceMasterData.find(p => p.practiceId === this.adduserDetails.userData.practiceID);
    
    if (practice) {
      console.log('✓ Found practice from practiceID:', practice.practiceId, '-', practice.name);
      
      // Populate requestor practice
      if (this.adduserDetails.userData.isRequestor) {
        if (!this.selectedPractice.some(p => p.practiceId === practice.practiceId)) {
          this.selectedPractice.push(practice);
          console.log('✓ Added to selectedPractice (requestor):', practice.name);
        }
      }
      
      // Populate L1 practice
      if (this.adduserDetails.userData.isL1) {
        if (!this.selectedL1Practice.some(p => p.practiceId === practice.practiceId)) {
          this.selectedL1Practice.push(practice);
          console.log('✓ Added to selectedL1Practice:', practice.name);
        }
      }
      
      // Populate L2 practice
      if (this.adduserDetails.userData.isL2) {
        if (!this.selectedL2Practice.some(p => p.practiceId === practice.practiceId)) {
          this.selectedL2Practice.push(practice);
          console.log('✓ Added to selectedL2Practice:', practice.name);
        }
      }
      
      console.log('Final selectedPractice:', this.selectedPractice);
      console.log('Final selectedL1Practice:', this.selectedL1Practice);
      console.log('Final selectedL2Practice:', this.selectedL2Practice);
    } else {
      console.log('✗ Practice NOT found for practiceID:', this.adduserDetails.userData.practiceID);
    }
  }
  
  // Update requestor practice dropdown (remove already selected items)
  this.practiceData = this.practiceMasterData
    .filter(practice => practice.practiceId !== 0)
    .filter(practice => !this.selectedPractice.some(selected => selected.practiceId === practice.practiceId))
    .sort((item1, item2) => (item1.name < item2.name ? -1 : 1));
  
  // Update L1 dropdown data (remove already selected items)
  this.L1cityData = this.MasterList.cityList.filter(city => 
    !this.selectedL1City.some(selected => selected.cityID === city.cityID)
  );
  
  this.L1practiceData = this.practiceMasterData
    .filter(practice => practice.practiceId !== 0)
    .filter(practice => !this.selectedL1Practice.some(selected => selected.practiceId === practice.practiceId));
  
  // Update L1 office data based on selected L1 cities
  if (this.selectedL1City.length > 0) {
    this.L1officeData = this.MasterList.officeList
      .filter(office => this.selectedL1City.some(city => city.cityID === office.cityID))
      .filter(office => !this.selectedL1Worklocation.some(selected => selected.officeID === office.officeID))
      .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  }
  
  // Update L2 dropdown data (remove already selected items)
  this.L2cityData = this.MasterList.cityList.filter(city => 
    !this.selectedL2City.some(selected => selected.cityID === city.cityID)
  );
  
  this.L2practiceData = this.practiceMasterData
    .filter(practice => practice.practiceId !== 0)
    .filter(practice => !this.selectedL2Practice.some(selected => selected.practiceId === practice.practiceId));
  
  // Update L2 office data based on selected L2 cities
  if (this.selectedL2City.length > 0) {
    this.L2officeData = this.MasterList.officeList
      .filter(office => this.selectedL2City.some(city => city.cityID === office.cityID))
      .filter(office => !this.selectedL2Worklocation.some(selected => selected.officeID === office.officeID))
      .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  }
}

  // selectNewWorkLocations(val){
  //   let i;
  //   if(val!=null)
  //   {
  //     if(this.selectSecuritySupervisorRole.isChecked == false )
  //     {
  //       if(this.selectedWorklocation.length>=1)
  //       {
  //          this.removeWorkLocation(null,this.selectedWorklocation[0]);
  //          let item=this.officeData.find(x=>x.officeID==this.OfficeSelected);
  //          this.selectedWorklocation.push(item);
  //          this.officeData=this.officeData.filter(x=>x.officeID!=item.officeID).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1); 
  //          //this.OfficeSelected = null;
  //       }

  //       else if(this.selectedWorklocation.length == 0)
  //       {
  //          let item=this.officeData.find(x=>x.officeID==this.OfficeSelected);
  //          this.selectedWorklocation.push(item);
  //          //this.OfficeSelected = null;
  //          this.officeData=this.officeData.filter(x=>x.officeID!=item.officeID).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1); 
           
  //         }
        
  //       // this.toast.success("For Admin, User & Super Admin only one Office");
  //       // this.OfficeSelected = null;
  //       // //this.removeWorkLocation(null,this.selectedWorklocation[0]);
  //     }

  //   else
  //     {      
  //       let item=this.officeData.find(x=>x.officeID==this.OfficeSelected);
  //       if(this.selectedWorklocation.indexOf(item)===-1)
  //       {
  //         this.selectedWorklocation.push(item);
  //       }    
  //       this.officeData=this.officeData.filter(x=>x.officeID!=item.officeID).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1); 
        
  //     }
  //   }
  // }

  selectNewWorkLocations(val) {
    if (val != null) {
        let item = this.officeData.find(x => x.officeID == this.OfficeSelected);

        // Add the selected work location to the list if not already present
        if (item && this.selectedWorklocation.indexOf(item) === -1) {
            this.selectedWorklocation.push(item);
        }

        // Remove the selected work location from the dropdown
        this.officeData = this.officeData.filter(x => x.officeID != item.officeID)
            .sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
    }
}

  selectWorlLocation()
  {
    let item=this.officeData.find(x=>x.officeID==this.OfficeSelected);
    if(this.selectedWorklocation.indexOf(item)===-1)
    {
      this.selectedWorklocation.push(item);
    }    
    this.officeData=this.officeData.filter(x=>x.officeID!=item.officeID).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
      
  }
  myFunction(k)
  {
    if (k==1 || k==2)
      {
        this.selectisrequestor.isChecked = true;
        this.selectisapprover.isChecked = true;   
        this.selectisL1approver.isChecked = true;
        this.selectisL2approver.isChecked = true;
        
        // Sync boolean flags for Admin/SuperAdmin
        this.isRequestor = true;
        this.isApprover = true;
        this.isL1 = true;
        this.isL2 = true;
      }
    else {
      // For User/SecuritySupervisor, reset checkboxes but keep selections
      this.selectisrequestor.isChecked = false;
      this.selectisapprover.isChecked = false;   
      this.selectisL1approver.isChecked = false;
      this.selectisL2approver.isChecked = false;
      
      // Sync boolean flags
      this.isRequestor = false;
      this.isApprover = false;
      this.isL1 = false;
      this.isL2 = false;
    }
    // Preserve all selections (selectedWorklocation, selectedCity, selectedPractice, L1/L2 selections) when switching roles
    // Arrays are intentionally NOT cleared to maintain user selections across role changes
  }

  selectNewCity($event) {
    // Find the newly selected city
    let item = this.cityData.find(x => x.cityID == this.CitySelected);
  
    if (this.RoleSelected === undefined || this.RoleSelected === null) {
      this.RoleSelected = this.adduserDetails.RoleId; // Default to the user's current role if not set
    }
  
    // Allow multiple cities for all roles: Admin, Super Admin, User, Security Supervisor
    if (item && this.selectedCity.indexOf(item) === -1) {
      this.selectedCity.push(item);
    }
  
    // Remove the newly selected city from the cityData array
    if (this.cityData && Array.isArray(this.cityData)) {
      // Remove undefined entries from cityData
      this.cityData = this.cityData.filter(x => x !== undefined);
  
      console.log('CitySelected:', this.CitySelected);
      console.log('Filtered cityData:', this.cityData);
  
      // Ensure CitySelected matches cityID type
      const citySelectedNumber = Number(this.CitySelected); // Convert to number if needed
      this.cityData = this.cityData
        .filter(x => x.cityID !== citySelectedNumber)
        .sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));
    } else {
      console.warn('cityData is undefined or not an array. Ensure it is initialized properly.');
    }
  
    // Update the officeData dropdown based on the selected cities
    let updatedOfficeData: Array<any> = [];
    this.selectedCity.forEach(city => {
      let cityOffices = this.MasterList.officeList.filter(office => office.cityID === city.cityID);
      updatedOfficeData = updatedOfficeData.concat(cityOffices);
    });
  
    // Exclude already selected work locations from the dropdown
    this.officeData = updatedOfficeData.filter(office =>
      !this.selectedWorklocation.some(workLocation => workLocation.officeID === office.officeID)
    ).sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  }

  removeWorkLocation($event, item): void {
    // Remove the work location from the selectedWorklocation array
    this.selectedWorklocation = this.selectedWorklocation.filter(x => x.officeID !== item.officeID);
  
    // Add the removed work location to the inactive work locations
    this.inActiveWorkLocation.push(item);
  
    // Check if there are no remaining work locations for the city
    const remainingWorkLocations = this.selectedWorklocation.filter(x => x.cityID === item.cityID);
    if (remainingWorkLocations.length === 0) {
      // Find the city object in the MasterList
      const city = this.MasterList.cityList.find(x => x.cityID === item.cityID);
      if (city) {
        // Remove the city from the selectedCity array
        this.selectedCity = this.selectedCity.filter(x => x.cityID !== city.cityID);
  
        // Add the city back to the city dropdown if not already present
        if (!this.cityData.some(x => x.cityID === city.cityID)) {
          this.cityData.push(city);
  
          // Sort the city dropdown alphabetically
          this.cityData.sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));
        }
      }
    }
  
    // Sort the officeData alphabetically
    this.officeData.sort((item1, item2) => (item1.officeName < item2.officeName ? -1 : 1));
  }

 removeCity(item): void {
  // Remove offices associated with the city being removed
  this.selectedWorklocation = this.selectedWorklocation.filter(x => x.cityID != item.cityID);

  this.officeData = this.officeData.filter(x => x.cityID != item.cityID);
  let data = this.selectedWorklocation.filter(x => x.cityID == item.cityID);
  
  // Move associated offices to inactive work locations
  for (var i = 0; i < data.length; i++) {
    this.inActiveWorkLocation.push(data[i]);
  }

  // Remove the city and its associated work locations from selected lists
  this.selectedWorklocation = this.selectedWorklocation.filter(x => x.cityID != item.cityID);
  this.selectedCity = this.selectedCity.filter(x => x.cityID != item.cityID);

  // Add the city back to the cityData list if it doesn't already exist
  if (this.cityData.indexOf(item) === -1) {
    this.cityData.push(item);
  }

  // Sort the cityData list alphabetically
  this.cityData.sort((item1, item2) => (item1.cityName < item2.cityName ? -1 : 1));
}


 
  // audittrail(addedWorkLocation:any, oldWorkLocation:any){
  //   this.setoldvalues(oldWorkLocation);
  //   this.setnewvalues(addedWorkLocation);
  //   this.oldValues.forEach(old=>{
  //     this.newValues.forEach(newvalue => {
  //      if(old.Name==newvalue.Name){
  //        if(old.Value!=newvalue.Value){
  //         let auditData: AuditTrail = new AuditTrail();
  //         auditData.oldValue=old.Value;
  //         auditData.newValue=newvalue.Value;
  //         auditData.actionPerformedOn = this.adduserDetails.userName
  //         auditData.eventType = AuditAttributes.auditData.modified;
  //         auditData.primaryKeyValue =this.adduserDetails.appUserId.toString();
  //         auditData.changedAttribute = this.getAttribute(old.Name);
  //         auditData.tableName = "ApplicationUser";            
  //         auditData.changedBy = window['userName'].value;
  //         this.auditResult.push(auditData);
  //        }
  //      }
  //     }
  //     )
  //   })
    
  // }
  // auditDisplay(auditValue,eventType,old,length){
  //   for(let i=0;i<length;i++){
  //     let auditData: AuditTrail = new AuditTrail()
  //     if(eventType=="Added"){
  //       auditData.newValue=auditValue.Value[i];
  //     }
  //     else if(eventType=="Deleted"){
  //       auditData.oldValue=auditValue.Value[i];
  //     }
  //     else{
  //       auditData.oldValue = old.Value;
  //        auditData.newValue = auditValue.Value;
  //     }
      
  //     auditData.actionPerformedOn = this.adduserDetails.userName
  //     auditData.eventType = eventType;
  //     auditData.primaryKeyValue =this.adduserDetails.appUserId.toString();
  //     auditData.changedAttribute = this.getAttribute(auditValue.Name);
  //     auditData.tableName = "ApplicationUser";            
  //     auditData.changedBy = window['userName'].value;
  //     this.auditResult.push(auditData);
  //   }

  // }
  getAttribute(attribute: string): string {
    let attributeValues;
    attributeValues = Object.keys(AuditAttributes.userAttribute).map(key => ({ Name: key, Value: AuditAttributes.userAttribute[key] }));
    attributeValues.forEach(result => {
      if (result.Name == attribute) {
        this.attributeName = result.Value;
      }
    });
    return this.attributeName;
  }
  // setoldvalues(oldWorkLocation){
  //   if(this.edituserDetail.RoleID==1){
  //     this.oldValues.RoleName=RoleType.Admin
  //   }
  //   else{
  //     this.oldValues.RoleName=RoleType.SecuritySupervisor
  //   }

  //   this.oldValues.isActive=this.edituserDetail.isActive?OnStatus.Active: OnStatus.Inactive;
  //  // this.oldValues.cityId=this.cityData.find(element=>element.cityId==this.edituserDetail.cityId).cityName;
  //   this.oldValues.offices=this.oldWorkLocation.map(office=>office.officeName).join();
  //   this.oldValues=Object.keys(this.oldValues).map(key => ({ Name: key, Value: this.oldValues[key] }))
    
  // }
  // setnewvalues( addedWorkLocation){
  //   if(this.adduserDetails.RoleId==1){
  //     this.newValues.RoleName=RoleType.Admin
  //   }
  //   else{
  //     this.newValues.RoleName=RoleType.SecuritySupervisor
  //   }
  //   this.newValues.isActive=this.adduserDetails.isActive?OnStatus.Active:OnStatus.Inactive;
  //   this.newValues.cityId=this.cityData.find(element=>element.cityID==this.adduserDetails.cityId).cityName;
  //   this.newValues.offices=addedWorkLocation.map(office=>office.officeName).join();
  //   this.newValues=Object.keys(this.newValues).map(key => ({ Name: key, Value: this.newValues[key] }))
  // }
  getUserOffices(addedWorkLocation){
    var userName = localStorage.getItem('email');
    
    // Add regular requestor offices
    for(let i=0;i<addedWorkLocation.length;i++){
      this.office= new UserOffices();
      this.office.officeID=addedWorkLocation[i].officeID;
      this.office.ChangedBy= userName;
      this.office.IsActive=true;
      this.office.UserId=this.adduserDetails.Id;
      this.office.AddedBy=userName;
      this.office.IsRequestor = this.selectisrequestor.isChecked;
      this.office.isL1 = false;
      this.office.isL2 = false;
     if(this.UserOffices.indexOf(this.office)===-1)
      {
      this.UserOffices.push(this.office);
      }
    }
    
    // Add L1 approver offices
    if(this.selectisL1approver.isChecked && this.selectedL1Worklocation.length > 0) {
      for(let i=0; i<this.selectedL1Worklocation.length; i++){
        this.office = new UserOffices();
        this.office.officeID = this.selectedL1Worklocation[i].officeID;
        this.office.ChangedBy = userName;
        this.office.IsActive = true;
        this.office.UserId = this.adduserDetails.Id;
        this.office.AddedBy = userName;
        this.office.IsRequestor = false;
        this.office.isL1 = true;
        this.office.isL2 = false;
        if(this.UserOffices.indexOf(this.office) === -1) {
          this.UserOffices.push(this.office);
        }
      }
    }
    
    // Add L2 approver offices
    if(this.selectisL2approver.isChecked && this.selectedL2Worklocation.length > 0) {
      for(let i=0; i<this.selectedL2Worklocation.length; i++){
        this.office = new UserOffices();
        this.office.officeID = this.selectedL2Worklocation[i].officeID;
        this.office.ChangedBy = userName;
        this.office.IsActive = true;
        this.office.UserId = this.adduserDetails.Id;
        this.office.AddedBy = userName;
        this.office.IsRequestor = false;
        this.office.isL1 = false;
        this.office.isL2 = true;
        if(this.UserOffices.indexOf(this.office) === -1) {
          this.UserOffices.push(this.office);
        }
      }
    }
    // for(let i=0;i<this.inActiveWorkLocation.length;i++){
    //   this.office= new UserOffices();
    //   this.office.officeID=this.inActiveWorkLocation[i].officeID;
    //   this.office.ChangedBy= userName;
    //   this.office.IsActive=false;
    //   this.office.UserId=this.adduserDetails.Id;
    //   this.office.AddedBy=userName;
    //   if(this.UserOffices.indexOf(this.office)===-1)
    //   {
    //   this.UserOffices.push(this.office);
    //   }
    // }
    
    // for(let i=0;i<this.UserOffices.length;i++)
    // {
    //   if(this.UserOffices[i].IsActive == false)
    //   {
    //     delete(this.UserOffices[i]);
    //   }
    // }
  }

  getRoleName(id){
    if(id == 1){
      return "Super Admin";
    }
    else if(id == 2){
      return "Admin";
    }
    else if(id == 3){
      return "Security Supervisor";
    }
    else if(id ==4){
      return "User";
    }
  }

  getCityFromMasterCity(cityId){
    var cityName = this.MasterList.cityList.filter((item) => {
      return item.cityID == cityId;
    })[0].cityName;

    return cityName;
  }
  

getCityIdsFromOffices(offices: any[]): number[] {
  if (!offices || offices.length === 0) return [];
  // offices can be array of office objects or office IDs
  const cityIds = offices
    .map(office => {
      // If office is an ID, find the office object
      if (typeof office === 'number') {
        const officeObj = this.MasterList.officeList.find(o => o.officeID === office);
        return officeObj ? officeObj.cityID : null;
      }
      // If office is an object, get cityID directly
      return office.cityID;
    })
    .filter((cityId, idx, arr) => cityId && arr.indexOf(cityId) === idx); // Unique & not null
  return cityIds;
}
  getOfficeFromMasterCity(officeId){
    var officeName = this.MasterList.officeList.filter((item) => {
      return item.officeID == officeId;
    })[0].officeName;
    
    return officeName;  
  }

  getPracticeFromMasterPractice(practiceId){
    var practiceName = this.practiceMasterData.filter((item) => {
      return item.practiceId == practiceId;
    })[0].name;

    return practiceName;
  }

  setOldValues(oldUserDetails: any, oldUserOffices: any){
    this.oldAuditValues.role = this.getRoleName(oldUserDetails[0].oldRoleId);
    //this.oldAuditValues.city = this.getCityIdsFromOffices(oldUserOffices);
    //const oldCityIds = this.getCityIdsFromOffices(oldUserOffices);
    //this.oldAuditValues.city = oldCityIds.map(cityId => this.getCityFromMasterCity(cityId));
     // --- Always get city from offices if present, else fallback to oldCityId ---
  let oldCityNames: string[] = [];
  const oldCityIds = this.getCityIdsFromOffices(oldUserOffices);
  if (oldCityIds.length > 0) {
    oldCityNames = oldCityIds.map(cityId => this.getCityFromMasterCity(cityId));
  } else if (oldUserDetails[0].oldCityId) {
    if (Array.isArray(oldUserDetails[0].oldCityId)) {
      oldCityNames = oldUserDetails[0].oldCityId.map(cityId => this.getCityFromMasterCity(cityId));
    } else {
      oldCityNames = [this.getCityFromMasterCity(oldUserDetails[0].oldCityId)];
    }
  }
  // Always set as string, not array
  this.oldAuditValues.city = oldCityNames.length > 0 ? oldCityNames.join(', ') : "";

    this.oldAuditValues.isActive = oldUserDetails[0].oldisActive == true ? "true" : "false";
    this.oldAuditValues.isRequestor = oldUserDetails[0].oldisRequestor == true ? "true" : "false";
    this.oldAuditValues.isApprover = oldUserDetails[0].oldisApprover == true ? "true" : "false";
    this.oldAuditValues.isL1 = oldUserDetails[0].oldisL1 == true ? "true" : "false";
    this.oldAuditValues.isL2 = oldUserDetails[0].oldisL2 == true ? "true" : "false";
    this.oldAuditValues.Practice = this.getPracticeFromMasterPractice(oldUserDetails[0].oldisPracticeID);

    var oldOffice: any = [];
    for(var i=0;i<oldUserOffices.length;i++){
      oldOffice.push(this.getOfficeFromMasterCity(oldUserOffices[i].officeID));
    }
    this.oldAuditValues.workLocation = oldOffice;

    this.oldAuditValues = Object.keys(this.oldAuditValues).map(key => ({Name: key, Value: this.oldAuditValues[key]}));
  }

  setNewValues(newUserDetails, newUserOffices){
    this.newAuditValues.role = this.getRoleName(newUserDetails.RoleId);
    //this.newAuditValues.city = this.getCityIdsFromOffices(newUserOffices);
    // Convert city IDs to city names
  // const newCityIds = this.getCityIdsFromOffices(newUserOffices);
  // this.newAuditValues.city = newCityIds.map(cityId => this.getCityFromMasterCity(cityId));
   // --- Always get city from offices if present, else fallback to selectedCity ---
  let newCityNames: string[] = [];
  const newCityIds = this.getCityIdsFromOffices(newUserOffices);
  if (newCityIds.length > 0) {
    newCityNames = newCityIds.map(cityId => this.getCityFromMasterCity(cityId));
  } else if (this.selectedCity && this.selectedCity.length > 0) {
    newCityNames = this.selectedCity.map(city => city.cityName);
  } else if (newUserDetails.cityId) {
    if (Array.isArray(newUserDetails.cityId)) {
      newCityNames = newUserDetails.cityId.map(cityId => this.getCityFromMasterCity(cityId));
    } else {
      newCityNames = [this.getCityFromMasterCity(newUserDetails.cityId)];
    }
  }
  // Always set as string, not array
  this.newAuditValues.city = newCityNames.length > 0 ? newCityNames.join(', ') : "";
    this.newAuditValues.isActive = newUserDetails.isActive == true ? "true" : "false";
    this.newAuditValues.isRequestor = newUserDetails.isRequestor == true ? "true" : "false";
    this.newAuditValues.isApprover = newUserDetails.isApprover == true ? "true" : "false";
    this.newAuditValues.isL1 = newUserDetails.isL1 == true ? "true" : "false";
    this.newAuditValues.isL2 = newUserDetails.isL2 == true ? "true" : "false";
    this.newAuditValues.Practice = this.getPracticeFromMasterPractice(newUserDetails.practiceID);

    var newOffice: any = [];
    for(var i=0;i<newUserOffices.length;i++){
      newOffice.push(this.getOfficeFromMasterCity(newUserOffices[i].officeID));
    }

    this.newAuditValues.workLocation = newOffice;

    this.newAuditValues = Object.keys(this.newAuditValues).map(key => ({Name: key, Value: this.newAuditValues[key]}));
  }

  convertToIST(date: any){
    date.setHours(date.getHours() + 5);
    date.setMinutes(date.getMinutes() + 30);
    var isodate = date.toISOString();

    return isodate;
  }

  //Audit Call
  // auditTrail(oldAuditData,newuserDetails, newUserOffices){
  //   this.setOldValues(this.oldValues, this.oldWorkLocation);
  //   this.setNewValues(newuserDetails, newUserOffices);
    
  //   //Comparison between old and new Values
  //   let auditData: AuditTrail = new AuditTrail();
  //   auditData.changedBy = localStorage.getItem('email');
  //   auditData.actionPerformed = "Update";
  //   auditData.actionPerformedOn = "User";
  //   auditData.primaryKey = newuserDetails.EmailId;
  //   auditData.dateChanged = this.convertToIST(new Date());
    
  //   let auditText: Array<AuditData> = new Array<AuditData>();

  //   this.oldAuditValues.forEach((oldV) => {
  //     this.newAuditValues.forEach((newV) => {
  //       if(oldV.Name != 'workLocation' && newV.Name != 'workLocation'){
  //         if(oldV.Name == newV.Name){
  //           if(oldV.Value != newV.Value){
  //             var obj : AuditData = new AuditData();
  //             obj.changedAttribute = oldV.Name;
  //             obj.oldValue = oldV.Value;
  //             obj.newValue = newV.Value;
  //             auditText.push(obj);
  //           }
  //         }
  //       }
  //       else{
  //         if(oldV.Name == 'workLocation' && newV.Name == 'workLocation'){
  //           var oldWL : any = oldV.Value;
  //           var newWL : any = newV.Value;

  //           if(oldWL.length == 1 && newWL.length == 1){
  //             if(oldWL[0] !== newWL[0]){
  //               var obj : AuditData = new AuditData();
  //               obj.changedAttribute = oldV.Name;
  //               obj.oldValue = oldWL[0];
  //               obj.newValue = newWL[0];
  //               auditText.push(obj);
  //             }
  //           }
  //           else{
  //             oldWL.forEach((oldValues) => {
  //               var flag = false;
  //               newWL.forEach((newValues) => {
  //                 if(oldValues === newValues){
  //                   flag = true;
  //                 }
  //               })
  //               if(!flag){
  //                 var obj : AuditData = new AuditData();
  //                 obj.changedAttribute = oldV.Name;
  //                 obj.oldValue = oldValues;
  //                 obj.newValue = null;
  //                 auditText.push(obj);
  //               }
  //             });

  //             newWL.forEach((newValues) => {
  //               var flag = false;
  //               oldWL.forEach((oldValues) => {
  //                 if(newValues === oldValues){
  //                   flag = true;
  //                 }
  //               })
  //               if(!flag){
  //                 var obj : AuditData = new AuditData();
  //                 obj.changedAttribute = oldV.Name;
  //                 obj.oldValue = null;
  //                 obj.newValue = newValues;
  //                 auditText.push(obj);
  //               }
  //             })
  //           }
  //       }
  //     }

  //     });  
  //   });

  //   auditData.messageText = auditText;
  //   this.auditResult = auditData;

  // }
   //Audit Call
// auditTrail(oldAuditData, newuserDetails, newUserOffices) {
//   this.setOldValues(this.oldValues, this.oldWorkLocation);
//   this.setNewValues(newuserDetails, newUserOffices);

//   //Comparison between old and new Values
//   let auditData: AuditTrail = new AuditTrail();
//   auditData.changedBy = localStorage.getItem('email');
//   auditData.actionPerformed = "Update";
//   auditData.actionPerformedOn = "User";
//   auditData.primaryKey = newuserDetails.EmailId;
//   auditData.dateChanged = this.convertToIST(new Date());

//   let auditText: Array<AuditData> = new Array<AuditData>();

//   this.oldAuditValues.forEach((oldV) => {
//     this.newAuditValues.forEach((newV) => {
//       if (
//         oldV.Name != 'workLocation' && newV.Name != 'workLocation' &&
//         oldV.Name != 'city' && newV.Name != 'city'
//       ) {
//         if (oldV.Name == newV.Name) {
//           if (oldV.Value != newV.Value) {
//             var obj: AuditData = new AuditData();
//             obj.changedAttribute = oldV.Name;
//             obj.oldValue = oldV.Value;
//             obj.newValue = newV.Value;
//             auditText.push(obj);
//           }
//         }
//       }
//       else {
//         if (oldV.Name == 'workLocation' && newV.Name == 'workLocation') {
//           var oldWL: any = oldV.Value;
//           var newWL: any = newV.Value;

//           if (oldWL.length == 1 && newWL.length == 1) {
//             if (oldWL[0] !== newWL[0]) {
//               var obj: AuditData = new AuditData();
//               obj.changedAttribute = oldV.Name;
//               obj.oldValue = oldWL[0];
//               obj.newValue = newWL[0];
//               auditText.push(obj);
//             }
//           }
//           else {
//             oldWL.forEach((oldValues) => {
//               var flag = false;
//               newWL.forEach((newValues) => {
//                 if (oldValues === newValues) {
//                   flag = true;
//                 }
//               })
//               if (!flag) {
//                 var obj: AuditData = new AuditData();
//                 obj.changedAttribute = oldV.Name;
//                 obj.oldValue = oldValues;
//                 obj.newValue = null;
//                 auditText.push(obj);
//               }
//             });

//             newWL.forEach((newValues) => {
//               var flag = false;
//               oldWL.forEach((oldValues) => {
//                 if (newValues === oldValues) {
//                   flag = true;
//                 }
//               })
//               if (!flag) {
//                 var obj: AuditData = new AuditData();
//                 obj.changedAttribute = oldV.Name;
//                 obj.oldValue = null;
//                 obj.newValue = newValues;
//                 auditText.push(obj);
//               }
//             })
//           }
//         }
//         // --- MULTIPLE CITY LOGIC ---
//         else if (oldV.Name == 'city' && newV.Name == 'city') {
//           var oldCities: any = oldV.Value;
//           var newCities: any = newV.Value;

//           if (Array.isArray(oldCities) && Array.isArray(newCities)) {
//             // Removed cities
//             oldCities.forEach((oldCity) => {
//               var flag = false;
//               newCities.forEach((newCity) => {
//                 if (oldCity === newCity) {
//                   flag = true;
//                 }
//               });
//               if (!flag) {
//                 var obj: AuditData = new AuditData();
//                 obj.changedAttribute = oldV.Name;
//                 obj.oldValue = oldCity;
//                 obj.newValue = null;
//                 auditText.push(obj);
//               }
//             });

//             // Added cities
//             newCities.forEach((newCity) => {
//               var flag = false;
//               oldCities.forEach((oldCity) => {
//                 if (newCity === oldCity) {
//                   flag = true;
//                 }
//               });
//               if (!flag) {
//                 var obj: AuditData = new AuditData();
//                 obj.changedAttribute = oldV.Name;
//                 obj.oldValue = null;
//                 obj.newValue = newCity;
//                 auditText.push(obj);
//               }
//             });
//           } else if (oldCities !== newCities) {
//             // Fallback for single city (string) case
//             var obj: AuditData = new AuditData();
//             obj.changedAttribute = oldV.Name;
//             obj.oldValue = oldCities;
//             obj.newValue = newCities;
//             auditText.push(obj);
//           }
//         }
        
//       }
//     });
//   });

//   auditData.messageText = auditText;
//   this.auditResult = auditData;
// }
auditTrail(oldAuditData, newuserDetails, newUserOffices) {
  this.setOldValues(this.oldValues, this.oldWorkLocation);
  this.setNewValues(newuserDetails, newUserOffices);

  //Comparison between old and new Values
  let auditData: AuditTrail = new AuditTrail();
  auditData.changedBy = localStorage.getItem('email');
  auditData.actionPerformed = "Update";
  auditData.actionPerformedOn = "User";
  auditData.primaryKey = newuserDetails.EmailId;
  auditData.dateChanged = this.convertToIST(new Date());

  let auditText: Array<AuditData> = new Array<AuditData>();

  this.oldAuditValues.forEach((oldV) => {
    this.newAuditValues.forEach((newV) => {
      if (
        oldV.Name != 'workLocation' && newV.Name != 'workLocation' &&
        oldV.Name != 'city' && newV.Name != 'city'
      ) {
        if (oldV.Name == newV.Name) {
          if (oldV.Value != newV.Value) {
            var obj: AuditData = new AuditData();
            obj.changedAttribute = oldV.Name;
            obj.oldValue = oldV.Value;
            obj.newValue = newV.Value;
            auditText.push(obj);
          }
        }
      }
      else {
        if (oldV.Name == 'workLocation' && newV.Name == 'workLocation') {
          var oldWL: any = oldV.Value;
          var newWL: any = newV.Value;

          if (oldWL.length == 1 && newWL.length == 1) {
            if (oldWL[0] !== newWL[0]) {
              var obj: AuditData = new AuditData();
              obj.changedAttribute = oldV.Name;
              obj.oldValue = oldWL[0];
              obj.newValue = newWL[0];
              auditText.push(obj);
            }
          }
          else {
            oldWL.forEach((oldValues) => {
              var flag = false;
              newWL.forEach((newValues) => {
                if (oldValues === newValues) {
                  flag = true;
                }
              })
              if (!flag) {
                var obj: AuditData = new AuditData();
                obj.changedAttribute = oldV.Name;
                obj.oldValue = oldValues;
                obj.newValue = null;
                auditText.push(obj);
              }
            });

            newWL.forEach((newValues) => {
              var flag = false;
              oldWL.forEach((oldValues) => {
                if (newValues === oldValues) {
                  flag = true;
                }
              })
              if (!flag) {
                var obj: AuditData = new AuditData();
                obj.changedAttribute = oldV.Name;
                obj.oldValue = null;
                obj.newValue = newValues;
                auditText.push(obj);
              }
            })
          }
        }
        // --- IMPROVED CITY LOGIC ---
        else if (oldV.Name == 'city' && newV.Name == 'city') {
          var oldCities: any = oldV.Value;
          var newCities: any = newV.Value;

          // Handle single city (string or array with one element)
          if (
            (typeof oldCities === 'string' || (Array.isArray(oldCities) && oldCities.length === 1)) &&
            (typeof newCities === 'string' || (Array.isArray(newCities) && newCities.length === 1))
          ) {
            let oldCityName = Array.isArray(oldCities) ? oldCities[0] : oldCities;
            let newCityName = Array.isArray(newCities) ? newCities[0] : newCities;
            if (oldCityName !== newCityName) {
              var obj: AuditData = new AuditData();
              obj.changedAttribute = oldV.Name;
              obj.oldValue = oldCityName || "";
              obj.newValue = newCityName || "";
              auditText.push(obj);
            }
          }
          // Handle multiple cities (array) case
          else if (Array.isArray(oldCities) && Array.isArray(newCities)) {
            // Removed cities
            oldCities.forEach((oldCity) => {
              var flag = false;
              newCities.forEach((newCity) => {
                if (oldCity === newCity) {
                  flag = true;
                }
              });
              if (!flag) {
                var obj: AuditData = new AuditData();
                obj.changedAttribute = oldV.Name;
                obj.oldValue = oldCity;
                obj.newValue = null;
                auditText.push(obj);
              }
            });

            // Added cities
            newCities.forEach((newCity) => {
              var flag = false;
              oldCities.forEach((oldCity) => {
                if (newCity === oldCity) {
                  flag = true;
                }
              });
              if (!flag) {
                var obj: AuditData = new AuditData();
                obj.changedAttribute = oldV.Name;
                obj.oldValue = null;
                obj.newValue = newCity;
                auditText.push(obj);
              }
            });
          } else if (oldCities !== newCities) {
            // Fallback for single city (string) case
            var obj: AuditData = new AuditData();
            obj.changedAttribute = oldV.Name;
            obj.oldValue = oldCities;
            obj.newValue = newCities;
            auditText.push(obj);
          }
        }
      }
    });
  });

  auditData.messageText = auditText;
  this.auditResult = auditData;
}


  
 //on clicking update
  onSubmit(Form: any) {
    var userName = localStorage.getItem('email');
    let addedWorkLocation= this.selectedWorklocation;
    this.getUserOffices(addedWorkLocation);
   
    if (this.selectAdminRole.isChecked) {
      this.adduserDetails.RoleId =  this.roleData.find(x=> x.roleName == Role.Admin).roleId;
    }
    else  if (this.selectSecuritySupervisorRole.isChecked) {
      this.adduserDetails.RoleId =   this.roleData.find(x=> x.roleName == Role.SecuritySupervisior).roleId;
    }
    else  if (this.selectSuperAdminRole.isChecked) {
        this.adduserDetails.RoleId =  this.roleData.find(x=> x.roleName == Role.SuperAdmin).roleId;
      }
    else{
      // For badge Executive
      this.adduserDetails.RoleId =   this.roleData.find(x=> x.roleName == Role.User).roleId;
    }
    if (this.selectActiveStatus.isChecked) {
      this.adduserDetails.isActive = true
    }
    else {
      this.adduserDetails.isActive = false
    }
    // if(this.selectedCity==null)
    // //this.adduserDetails.cityId = this.selectedCity[0].cityID;
    // this.adduserDetails.cityId = this.selectedCity.map(city => city.cityID);
    // if(this.adduserDetails.RoleId == 3)
    // {
    //   for(let i=0;i<addedWorkLocation.length;i++){
    //   this.adduserDetails.officeID[i] = this.selectedWorklocation[i];
    // }
    //  } 
    // else
    // {
    //   this.adduserDetails.officeID = this.selectedWorklocation[0].officeID;
    // }
   if (!this.selectedCity || this.selectedCity.length === 0) {
  this.adduserDetails.cityId = null;
} else {
  // For DB, set cityId to the first selected city (from selected offices if possible)
  const selectedCityIds = this.selectedWorklocation
    .map(office => office.cityID)
    .filter((value, index, self) => value && self.indexOf(value) === index);
  this.adduserDetails.cityId = selectedCityIds.length > 0 ? selectedCityIds[0] : this.selectedCity[0].cityID;
}

// Keep your logic for roleId == 3 (multiple offices for UserOffices), 
// but always send a single officeID (first one) for ApplicationUser.officeID (DB expects int)
if (this.adduserDetails.RoleId == 3) {
  // For UserOffices table (handled by UserOffices array)
  this.adduserDetails.officeID = this.selectedWorklocation[0]?.officeID || null;
  // UserOffices array is already handled by this.getUserOffices(addedWorkLocation);
} else {
  this.adduserDetails.officeID = this.selectedWorklocation[0]?.officeID || null;
}
    this.adduserDetails.appUserID = this.adduserDetails.userData.appUserID;
    this.adduserDetails.firstName = this.adduserDetails.userData.firstName;
    this.adduserDetails.lastName = this.adduserDetails.userData.lastName;
    this.adduserDetails.dateAdded = this.oldDateAdded;
    this.adduserDetails.isApprover = this.selectisapprover.isChecked;
    this.adduserDetails.isRequestor = this.selectisrequestor.isChecked;
    this.adduserDetails.isL1 = this.selectisL1approver.isChecked;
    this.adduserDetails.isL2 = this.selectisL2approver.isChecked;
    
    // For Admin/SuperAdmin: always use PracticeSelected; For others: use PracticeSelected only if approver is checked
    if(this.adduserDetails.RoleId == 1 || this.adduserDetails.RoleId == 2) {
      this.adduserDetails.practiceID = this.PracticeSelected || 0;
    } else {
      this.adduserDetails.practiceID = this.selectisapprover.isChecked ? this.PracticeSelected : 0;
    }
    
    this.adduserDetails.changedBy = userName;
    this.adduserDetails.AddedBy = this.oldAddedBy;
    
    // Set officeID and cityID from requestor locations, or fallback to L1/L2 locations
    if(this.selectedWorklocation.length > 0) {
      this.adduserDetails.officeID = this.selectedWorklocation[0].officeID;
      this.adduserDetails.cityId = this.selectedWorklocation[0].cityID;
    } else if(this.selectedL1Worklocation.length > 0) {
      this.adduserDetails.officeID = this.selectedL1Worklocation[0].officeID;
      this.adduserDetails.cityId = this.selectedL1Worklocation[0].cityID;
    } else if(this.selectedL2Worklocation.length > 0) {
      this.adduserDetails.officeID = this.selectedL2Worklocation[0].officeID;
      this.adduserDetails.cityId = this.selectedL2Worklocation[0].cityID;
    } else {
      this.adduserDetails.officeID = null;
      this.adduserDetails.cityId = null;
    }
    
    // Build userPractices array
    this.UserPractices = []; // Clear existing practices
    
    // For Admin and Super Admin: add practice with isL1=false, isL2=false
    if((this.adduserDetails.RoleId == 1 || this.adduserDetails.RoleId == 2) && this.PracticeSelected) {
      this.practice = new UserPractices();
      this.practice.PracticeId = this.PracticeSelected;
      this.practice.AddedBy = userName;
      this.practice.ChangedBy = userName;
      this.practice.IsActive = true;
      this.practice.isL1 = false;
      this.practice.isL2 = false;
      this.UserPractices.push(this.practice);
    }
    
    // Build userPractices array for L1
    if(this.selectisL1approver.isChecked && this.selectedL1Practice.length > 0) {
      for(let i = 0; i < this.selectedL1Practice.length; i++) {
        this.practice = new UserPractices();
        this.practice.PracticeId = this.selectedL1Practice[i].practiceId;
        this.practice.AddedBy = userName;
        this.practice.ChangedBy = userName;
        this.practice.IsActive = true;
        this.practice.isL1 = true;
        this.practice.isL2 = false;
        this.UserPractices.push(this.practice);
      }
    }
    
    // Build userPractices array for L2
    if(this.selectisL2approver.isChecked && this.selectedL2Practice.length > 0) {
      for(let i = 0; i < this.selectedL2Practice.length; i++) {
        this.practice = new UserPractices();
        this.practice.PracticeId = this.selectedL2Practice[i].practiceId;
        this.practice.AddedBy = userName;
        this.practice.ChangedBy = userName;
        this.practice.IsActive = true;
        this.practice.isL1 = false;
        this.practice.isL2 = true;
        this.UserPractices.push(this.practice);
      }
    }
    
    //this.audittrail(addedWorkLocation,this.oldWorkLocation);
    //Audit Trail
    this.auditTrail(this.oldAuditData,this.adduserDetails, this.UserOffices);
    
    this.userService.UpdateUsersData(this.adduserDetails,this.UserOffices, this.UserPractices) 
    .pipe(takeUntil(this.unsubscribe$)).subscribe(
      (resultArray) => {
        if (resultArray != 0) {
          //this.userService.refreshwithFilters.next();
          this.toast.success("Successfully updated!");
        }
        else {
          this.toast.error("Some thing went on wrong..");
          this.modalRef.hide();
        }
      },
      (err) => {
        this.toast.error("Some thing went on wrong..");
        console.log(err);
      },
      () => {
        //Saving Data in Audit Trail
          let auditParams = {
            actionPerformed : this.auditResult.actionPerformed,
            actionPerformedOn : this.auditResult.actionPerformedOn,
            changedBy : this.auditResult.changedBy,
            dateChanged : this.auditResult.dateChanged,
            primaryKey : this.auditResult.primaryKey,
            messageText : this.auditResult.messageText
          };
         /* this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.saveconfigaudittrail,auditParams)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((res) => {
            // console.log(res);
          },
          (err) => {
            console.log(err);
          },
          () => {
            window.location.reload();
          })
      */

      // Convert all oldValue/newValue in messageText to strings
        //if (Array.isArray(auditParams.messageText)) {
        //  auditParams.messageText = auditParams.messageText.map((item: any) => ({
        //    ...item,
        //    oldValue: item.oldValue !== null && item.oldValue !== undefined ? String(item.oldValue) : "",
        //    newValue: item.newValue !== null && item.newValue !== undefined ? String(item.newValue) : ""
        //  }));
        //}
        
      let tokenNew = localStorage.getItem('accessToken');
    var headers=new HttpHeaders({ 
      'Authorization' : `Bearer ${tokenNew}`
    })
    this.http.post<any>(this.service_URL.AuditTrail.saveconfigaudittrail, auditParams,{headers:headers})
      .subscribe(res => { 
        console.log(res);
      },
      (err)=>{
        console.log(err);
      },
      ()=>{
        this.userService.refreshwithFilters.next();
        this.modalRef.hide();
      }
      );
    });
  }

  
  

  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}



